import Constants from '../constants/Constants';
import userApi from './userApi';
import config from './config';
import {updateSelfIdentifiedUserProviderState} from '../context/selfIdentifiedUserProvider';

const setSelfIdentifiedUser = async (displayName: string): Promise<void> => {
   const user = await userApi.createSelfIdentifiedUser(displayName);

   window.localStorage.setItem(Constants.localStorageKeys.selfIdentifiedId, user.Id);
   window.localStorage.setItem(Constants.localStorageKeys.selfIdentifiedName, user.DisplayName);
   window.localStorage.setItem(Constants.localStorageKeys.selfIdentifiedSecret, user.Secret);

   config.user.Secret = user.Secret;
   config.user.DisplayName = user.DisplayName;
   config.user.TechSmithId = user.Id;

   updateSelfIdentifiedUserProviderState({userIsSelfIdentified: true});
};

const setupSelfIdentifiedUserFromLocalStorage = (): void => {
   const {selfIdentifiedId, selfIdentifiedName, selfIdentifiedSecret} = Constants.localStorageKeys;
   try {
      const userId = window.localStorage.getItem(selfIdentifiedId);
      const secret = window.localStorage.getItem(selfIdentifiedSecret);
      const name = window.localStorage.getItem(selfIdentifiedName);

      if (userId && secret && name) {
         config.user.Secret = secret;
         config.user.DisplayName = name;
         config.user.TechSmithId = userId;
         updateSelfIdentifiedUserProviderState({userIsSelfIdentified: true});
      }
   } catch (e) {
      console.warn('Could not get self identified users from local storage');
   }
};

const forgetSelfIdentifiedUser = (): void => {
   const {selfIdentifiedId, selfIdentifiedName, selfIdentifiedSecret} = Constants.localStorageKeys;
   window.localStorage.removeItem(selfIdentifiedId);
   window.localStorage.removeItem(selfIdentifiedName);
   window.localStorage.removeItem(selfIdentifiedSecret);

   config.user.Secret = '';
   config.user.DisplayName = '';
   config.user.TechSmithId = Constants.nullTechSmithId;

   updateSelfIdentifiedUserProviderState({userIsSelfIdentified: false});
};

export default {
   setSelfIdentifiedUser,
   setupSelfIdentifiedUserFromLocalStorage,
   forgetSelfIdentifiedUser
};
